import { Spin, Table } from 'antd';
import { styled } from 'styled-components';
import LoadingError from '../../ui/error/LoadingError';
import { Excel } from 'antd-table-saveas-excel';
import DownloadButton from '../../ui/DownloadButton';

const MarketPriceTable = (props) => {
    const { dataSource, isError, isLoading } = props;

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }
    console.log(nullColumns)

    const columns = [
      {
        title: 'Product Name',
        dataIndex: 'product_name',
        key: 'product_name',
      },
      {
        title: 'Bid',
        dataIndex: 'bid',
        key: 'bid',
      },
      {
        title: 'Ask',
        dataIndex: 'ask',
        key: 'ask',
      },
      {
        title: 'Trade',
        dataIndex: 'trade',
        key: 'trade',
      },
      {
        title: 'Tenure',
        dataIndex: 'tenure',
        key: 'tenure',
      },
      {
        title: 'Issuer Name',
        dataIndex: 'issuer_name',
        key: 'issuer_name',
      },
      // {
      //   title: 'Issued Date',
      //   dataIndex: 'issued_date',
      //   key: 'issued_date',
      //   render: (_, { issued_date }) => issued_date && issued_date.split(' ')[0]
      // },
      {
        title: 'Coupon Rate',
        dataIndex: 'coupon_rate',
        key: 'coupon_rate',
      },
      {
        title: 'Maturity Date',
        dataIndex: 'maturity_date',
        key: 'maturity_date',
        render: (_, { maturity_date }) => maturity_date && maturity_date.split(' ')[0]
      },
      {
        title: 'ISIN',
        dataIndex: 'ISIN',
        key: 'ISIN',
      },
      // {
      //   title: 'RICS',
      //   dataIndex: 'RICS',
      //   key: 'RICS',
      // },
      // {
      //   title: 'LTP',
      //   dataIndex: 'LTP',
      //   key: 'LTP',
      // },
      {
        title: 'Updated On',
        dataIndex: 'addedOn',
        key: 'addedOn',
        render: (_, { addedOn }) => addedOn && addedOn
      },
    ].filter((item) => !nullColumns.includes(item.key));

    function excelExportHandler() {
      const excel = new Excel();
      excel.addSheet("Sheet 1")
      .addColumns(columns)
      .addDataSource(dataSource, { str2Percent: true })
      .saveAs("MarketPrice.xlsx");
    }

  if(isLoading) return (
    <Spin 
        tip="Loading" 
        size="large" 
        className='loading-spiner'
    />
  );
  if(isError) return <LoadingError />;

  return (
      <Wrapper>
          <DownloadButton onClick={excelExportHandler}>Export</DownloadButton>
          <div className='card'>
              <Table 
              dataSource={dataSource}
              bordered
              size='small'
              columns={columns} 
              style={{
                  marginTop: '10px',
                  padding: 0,
              }}
              // scroll={{ x: 1200 }}
              />
          </div>
      </Wrapper>
  );
}

export default MarketPriceTable;

const Wrapper = styled.div`
    /* width: 95%;
    margin: auto; */
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

